<template>
  <div>
    <div :class="'popup' + visible">
      <div :class="'popup__content popup__content--' + size">
        <div :class="header">
          <div v-if="classTitle" :class="classTitle">{{ title }}</div>
          <div v-else class="popup__title">{{ title }}</div>
        </div>
        <span v-if="classTitle" class="popup__close" @click="toggleModal"
          ><img src="../../static/icons/Cerrar.svg" alt="cerrar"
        /></span>
        <span v-else class="popup__close" @click="toggleModal">x</span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["size", "title", "header", "classTitle"],
  name: "Popup",
  data() {
    return {
      open: false,
    };
  },
  computed: {
    visible() {
      return this.open ? " popup--visible" : "";
    },
  },
  methods: {
    toggleModal() {
      this.open = !this.open;
    },
  },
};
</script>


<style>
.popup {
  z-index: 1030;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
}

.popup--visible {
  opacity: 1;
  visibility: visible;
}

.popup__content {
  position: absolute;
  top: 28%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  background-color: #fff;
  box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  display: table;
  overflow: hidden;
  z-index: 99998;
  padding: 5rem;
}

.popup__content--xxs {
  width: 15%;
}

.popup__content--xs {
  width: 25%;

 
}

.popup__content--sm {
  width: 40%;

}

.popup__content--sm-mod {
  width: 60%;
  max-width: 600px;
  background-color: #3a8a65;
}
.popup__content--sm-mod2 {
  width: 60%;
}

.popup__content--md {
  width: 50%;
  height: 50%;
  display: block;
  /* overflow: auto; */
}
.popup__content--md-mod2 {
  height: 35%;
  width: 35%;

  display: block;
  /* overflow: auto; */
}

.popup__content--md-mod3 {
  height: auto;
  max-width: 90%;
  margin: 0 auto;
  display: block;
  padding: 5rem 2rem 0 2rem;
  width: 700px;
}

.popup__content--md-mod {
  height: 60%;
  width: 50%;
  display: block;
  overflow: auto;
}

.popup__content--lg {
  width: 60%;
  height: 65rem;
  display: block;
  overflow: auto;
}
.popup__content--lg-extra {
  width: 70%;
  height: 70rem;
  display: block;
}

.popup__content--lg-extra2 {
  width: 100%;
  height: 70rem;
  display: block;
  overflow: auto;
  position: fixed;
}

.popup__close {
  position: absolute;
  top: 1rem;
  right: 2rem;
  font-size: 1.5rem;
  font-weight: 400;
  cursor: pointer;
  color: #828282;
}

.popup__close-mod {
  position: absolute;
  top: 1rem;
  right: 2rem;
  font-size: 1.5rem;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
}

.popup__header {
  height: 4rem;
  width: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background-color: #67a3cf;
}
.popup__header-admin {
  height: 4rem;
  width: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background-color: #67a3cf;
}

.popup__header-edit {
  height: 4rem;
  width: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background-color: #fff;
}

.popup__title-mod {
  position: absolute;
  top: 1.2rem;
  left: 2rem;
  right: 3rem; /* Espacio para el botón de cerrar el modal */
  font-size: 21px;
  font-weight: 600;
  font-family: "OpenSans-Semibold";
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  white-space: nowrap; /* Evita que el texto se divida en varias líneas */
  overflow: hidden;
  text-overflow: ellipsis;
}

.popup__title {
  position: absolute;
  top: 1rem;
  left: 5rem;
  font-size: 24px;
  font-weight: 600;
  font-family: "OpenSans-Bold";
  color: #000;
}

.popup__loader {
  position: absolute;
  top: 1rem;
  left: 5rem;
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Open Sans;
  color: #000;
}
/* 
@media (max-width: 99.8rem) {
  .popup__content--sm {
    width: 40%;
  }
  .popup__content--xs {
    width: 25%;
  }
}

@media (max-width: 76.8rem) {
  .popup__content--xs {
    width: 60%;
  }
} */

@media (max-height: 700px) {
  .popup__content--md-mod2 {
    height: 45%;
    width: 50%;
  }
}
</style>